import React from "react";
 
const GreyArrowIcon = ({ color = "grey", style = {} }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: "0px 5px",
        verticalAlign: "middle",
        ...style
      }}
    >
      <path
        d="M6.72269 8.00018L0.589355 1.86685L1.53335 0.922852L8.61069 8.00018L1.53335 15.0775L0.589355 14.1335L6.72269 8.00018Z"
        fill={color}
      />
    </svg>
  );
};
 
export default GreyArrowIcon;
 
 